import { render, staticRenderFns } from "./comp_Footer-LinkList.vue?vue&type=template&id=c7b8b9cc&scoped=true&"
import script from "./comp_Footer-LinkList.vue?vue&type=script&lang=js&"
export * from "./comp_Footer-LinkList.vue?vue&type=script&lang=js&"
import style0 from "./comp_Footer-LinkList.vue?vue&type=style&index=0&id=c7b8b9cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7b8b9cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
